import type { Comic } from "@/mocks/comics";

export default function ComicCard({ comic }: { comic: Comic }) {
  return (
    <article className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[5/7] w-full overflow-hidden bg-background-100">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩漫封面`}
          title={`${comic.title} - ${comic.tags.join(" / ")}`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs text-background-50 backdrop-blur">
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-medium text-background-50">
          <i className="ri-star-fill text-[11px]" aria-hidden="true" />
          {comic.rating.toFixed(1)}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-3.5 md:p-4">
        <h3 className="font-heading text-base font-bold text-foreground-900">
          <a href="#featured" className="transition-colors hover:text-primary-600">
            {comic.title}
          </a>
        </h3>
        <div className="mt-2 flex flex-wrap gap-1.5">
          {comic.tags.map((t) => (
            <span
              key={t}
              className="whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900"
            >
              {t}
            </span>
          ))}
        </div>
        <p className="mt-2.5 line-clamp-3 flex-1 text-xs leading-relaxed text-foreground-600">
          {comic.summary}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-2.5 text-xs text-foreground-500">
          <span>{comic.chapters} 话</span>
          <span className="flex items-center gap-1">
            <i className="ri-fire-fill text-primary-500" aria-hidden="true" />
            {comic.views}
          </span>
        </div>
      </div>
    </article>
  );
}